import { StrictMode,useEffect,useState } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { LanguageProvider } from './locales/I18n';
import './forest.css';
import './auth/account.css';
import './auth/login.css';
import {AuthProvider,useAccount} from './auth/AuthProvider';
import {CatalogueProvider} from './catalogue/CatalogueProvider';
import {LoginPage} from './components/LoginPage';
import {EmailAuthPage} from './components/EmailAuthPage';
import {PublicPages} from './components/PublicPages';
import './services.css';
import './settings.css';
import './progress-badges.css';
import './focused-reader.css';
import './narration.css';
import './celebrations.css';
import {LaunchGate,LoadingState} from './components/LaunchScreen';
import {ProfileProvider} from './auth/ProfileProvider';
import {OnboardingGate} from './components/Onboarding';
import './onboarding.css';
import './bookmarks.css';
import './ads/ads.css';
import './locales/fonts.css';
import {WebAdsProvider} from './ads/WebAds';
import {webAdMode} from './ads/providers';
import {routePath,bridgeLegacyRoutes} from './navigation';
import {Capacitor} from '@capacitor/core';
if(webAdMode==='adsense'&&!Capacitor.isNativePlatform())bridgeLegacyRoutes();

function AccountApp(){
 const {user,ready,busy}=useAccount();const [path,setPath]=useState(routePath);
 useEffect(()=>{const update=()=>setPath(routePath());addEventListener('hashchange',update);addEventListener('popstate',update);return()=>{removeEventListener('hashchange',update);removeEventListener('popstate',update);};},[]);
 const publicPage=/^\/(support|privacy|terms|delete-account)(\/|$)/.test(path);
 const authPage=['/login','/login/email','/signup','/reset-password'].includes(path);
 useEffect(()=>{
  if(!ready||busy||publicPage)return;
  if(user&&(authPage||path==='/'))location.hash='/home';
  
 },[path,ready,busy,user,publicPage,authPage]);
 if(publicPage)return <PublicPages page={path}/>;
 if(!ready||(user&&busy&&authPage))return <LoadingState/>;
 if(!user){
  if(path==='/login/email'||path==='/signup'||path==='/reset-password')return <EmailAuthPage key={path} mode={path==='/signup'?'signup':path==='/reset-password'?'reset':'login'}/>;
  if(authPage||path==='/')return <LoginPage/>;
  return <ProfileProvider user={null}><CatalogueProvider><WebAdsProvider><App key="guest"/></WebAdsProvider></CatalogueProvider></ProfileProvider>;
 }
 if(authPage||path==='/')return <LoadingState/>;
 return <ProfileProvider key={user.uid} user={user}><OnboardingGate><CatalogueProvider><WebAdsProvider><App key={user.uid}/></WebAdsProvider></CatalogueProvider></OnboardingGate></ProfileProvider>;
}

createRoot(document.getElementById('root')!).render(<StrictMode><LanguageProvider><AuthProvider><LaunchGate><AccountApp/></LaunchGate></AuthProvider></LanguageProvider></StrictMode>);
